<template>
  <div class="field">
    <label class="label" v-if="label">{{ label }}</label>
    <div class="buttons has-addons">
      <span
        class="button"
        @click="onChange(true)"
        :class="{ 'is-primary': value }"
        >{{ positiveLabel }}</span
      >
      <span
        class="button"
        @click="onChange(false)"
        :class="{ 'is-dark': !value }"
        >{{ negativeLabel }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "toggle-button-field",
  props: ["value", "label", "positiveLabel", "negativeLabel"],
  methods: {
    onChange(value) {
      this.$emit("change", value)
      this.$emit("input", value)
    }
  }
}
</script>
